<template>
    <div class="shop-qr-info">
        <div class="shop-qr">
            <van-image width="100%" :src="qr_url" class="qr-image" />
            <van-image src="https://public.qiniu.xcims.com/wxshare-logo.png" class="logo-water" />
        </div>
        <div class="shop-info">
            <div class="title">
                {{ shop_name }}
            </div>
            <div class="tel">
                {{ shop_tel }}
            </div>
            <div class="address">
                {{ shop_address }}
            </div>
            <div class="desc">
                点击右上方分享按钮，可以把店铺二维码分享给好友。
            </div>
        </div>
    </div>
</template>

<script>
import { NavBar, Image as VanImage, Cell } from 'vant'

export default {
    components: {
        [NavBar.name]: NavBar,
        [VanImage.name]: VanImage,
        [Cell.name]: Cell,
    },
    data() {
        return {}
    },
    props: [ 'qr_url', 'shop_name', 'shop_tel', 'shop_address'],
    mounted() {},
    methods: {}
}
</script>

<style lang="less" scoped>
.shop-qr-info {
    .shop-qr {
        display: flex;
        align-items:center;
        justify-content:center;

        .qr-image {
            z-index: 0;
        }

        .logo-water {
            z-index: 9999;
            width: 60px;  /* Or whatever */
            height: 60px; /* Or whatever */
            margin: auto;  /* Magic! */
            // opacity: 0.5;
            position: absolute;
        }
    }
    .shop-info {
        text-align: center;

        .title {
            margin-top: 1em;
            font-size: 1.2em;
            font-weight: bold;
        }
        .tel {
            margin-top: 1em;
        }
        .address {
            margin-top: 1em;
        }
        .desc {
            margin-top: 2em;
            font-size: 0.9em;
        }
    }
}

</style>